/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITwoColumnLayoutViewProps } from './two-column-layout';

export default (props: ITwoColumnLayoutViewProps) => {
	return (
		<div className="default-container container">
			<div className="row">
				<div className={` ${props.config.cusLeftBootstrapClass}`}>
					{/*<div dangerouslySetInnerHTML={{ __html:props.config.cusLeftTextfield}} />*/}
				</div>
				<div className={` ${props.config.cusRightBootstrapClass}`}>
					<div className="ms-iframe warranty-form mt-3" id="" data-m-t="iframe">
						<h2 className="ms-iframe__heading">{props.config.cusRightIframeHeading}</h2>
						<iframe className="ms-iframe__content" src={props.config.cusRightIframeSrc} height="100%" aria-label={`${props.config.cusRightIframeAriaLabel}`}></iframe>
					</div>
				</div>
			</div>
		</div>
	);
};
